<template>
  <section class="service_benefits_area text-center section_border section_padding">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="hero-section-title">
            <h1>Our benefits</h1>
          </div><!--end .hero-section-title-->
        </div><!--end .col-md-12-->
        <div class="col-md-3 col-sm-6">
          <div class="service_benefits_box">
            <i class="icon-big_clock"></i>
            <h3>Emergency Service</h3>
            <p>Our phones are in service 24 hours a day because plumbing emergencies don't happen on schedule. </p>
          </div><!--end .service_benefits_box-->
        </div><!--end col-md-3-->
        <div class="col-md-3 col-sm-6">
          <div class="service_benefits_box">
            <i class="icon-wallet"></i>
            <h3>No Upfront Payment</h3>
            <p>We don't collect payments until you are completely satisfied.</p>
          </div><!--end .service_benefits_box-->
        </div><!--end col-md-3-->
        <div class="col-md-3 col-sm-6">
          <div class="service_benefits_box">
            <i class="icon-diploma"></i>
            <h3>Satisfaction Guarantee</h3>
            <p>Your satisfaction is 100% guaranteed.  We will continue to support you after our work is done.</p>
          </div><!--end .service_benefits_box-->
        </div><!--end col-md-3-->
        <div class="col-md-3 col-sm-6">
          <div class="service_benefits_box">
            <i class="icon-mechanic"></i>
            <h3>40 Years Experience</h3>
            <p>Gas, water, and sewer installation shoudld always be performed by a professional.  Let our friendly expert professionals help you.</p>
          </div><!--end .service_benefits_box-->
        </div><!--end col-md-3-->
      </div><!--end .row-->
    </div><!--end .container-->
  </section>
</template>

<script>
    export default {
      name: "Benefits"
    }
</script>

<style scoped>

</style>
